import React, { useState } from 'react';
import MediaLibrary from 'aldoo-ra/MediaLibrary';

const MediaPickerField = ({ value, onChange }) => {
  const [open, setOpen] = useState(false);

  const handleFileSelect = (file) => {
    onChange(file.url || file.path || '');
    setOpen(false);
  };

  return (
    <div className="space-y-1.5">
      {value ? (
        <div className="relative w-full h-24 rounded border border-slate-200 overflow-hidden bg-slate-50">
          <img src={value} alt="preview" className="w-full h-full object-contain" />
          <button
            onClick={() => onChange('')}
            className="absolute top-1 right-1 w-5 h-5 rounded-full bg-black/50 text-white text-xs flex items-center justify-center hover:bg-black/70"
            title="Remove"
          >
            ×
          </button>
        </div>
      ) : (
        <div className="w-full h-24 rounded border border-dashed border-slate-300 bg-slate-50 flex items-center justify-center text-slate-400 text-xs">
          No image selected
        </div>
      )}
      <button
        onClick={() => setOpen(true)}
        className="w-full py-1 text-xs rounded border border-slate-200 bg-white hover:bg-slate-50 text-slate-600 transition-colors"
      >
        {value ? 'Change Image' : 'Choose Image'}
      </button>
      {open && (
        <MediaLibrary
          isOpen={open}
          onClose={() => setOpen(false)}
          onFileSelect={handleFileSelect}
          defaultFileType="image"
        />
      )}
    </div>
  );
};

export default MediaPickerField;
